import { http } from "../../../engine/api/http";
import { MERGE_TIMEOUT_MS } from "./institutionMerge.constants";

const long = { timeout: MERGE_TIMEOUT_MS };
const base = "/institutions/merge";

/** Every merge call in one place; long-running ones get the 15-minute timeout. */
export const mergeApi = {
  create: (sourceIds, configDonorId, label, targetInstitutionId, targetName) =>
    http
      .post(
        base,
        { sourceIds, configDonorId, label, targetInstitutionId, targetName },
        long,
      )
      .then(r => r.data),
  /** Every record a merge will touch, with before → after per field; `key` is a registry key or "institutions". */
  records: (id, { key, sourceId, page = 1, limit = 50 }) =>
    http
      .post(`${base}/${id}/records`, { key, sourceId, page, limit }, long)
      .then(r => r.data),
  get: id => http.get(`${base}/${id}`).then(r => r.data),
  /** The final check, one section at a time: every entity before / after with the kind of each change (split view). */
  review: (id, params) =>
    http.get(`${base}/${id}/review`, { params, ...long }).then(r => r.data),
  refresh: id => http.post(`${base}/${id}/refresh`, {}, long).then(r => r.data),
  decisions: (id, decisions) =>
    http.put(`${base}/${id}/decisions`, decisions).then(r => r.data),
  apply: id => http.post(`${base}/${id}/apply`, {}, long).then(r => r.data),
  verify: id => http.post(`${base}/${id}/verify`, {}, long).then(r => r.data),
  validate: (id, note, qaChecklist) =>
    http
      .post(`${base}/${id}/validate`, { note, qaChecklist })
      .then(r => r.data),
  finalize: id => http.post(`${base}/${id}/finalize`, {}).then(r => r.data),
  discard: id => http.delete(`${base}/${id}`).then(r => r.data),
  resume: id => http.post(`${base}/${id}/resume`, {}, long).then(r => r.data),
  restorePreview: id =>
    http.post(`${base}/${id}/restore/preview`, {}, long).then(r => r.data),
  detachPreview: (id, sourceId) =>
    http
      .post(`${base}/${id}/detach/preview`, { sourceId }, long)
      .then(r => r.data),
  detach: (id, sourceId, body) =>
    http
      .post(`${base}/${id}/detach`, { sourceId, ...body }, long)
      .then(r => r.data),
  restore: (id, body) =>
    http.post(`${base}/${id}/restore`, body, long).then(r => r.data),
  history: (page = 1, limit = 25, status, q) =>
    http
      .get(`${base}/history`, { params: { page, limit, status, q } })
      .then(r => r.data),
  /** Every document a merge touched, with every field it changed (before → after); q searches the labels. */
  documents: (id, params) =>
    http.get(`${base}/${id}/documents`, { params, ...long }).then(r => r.data),
  /** The complete card of one touched document: every field, before / after (merge) / current. */
  document: (id, model, documentId) =>
    http
      .get(`${base}/${id}/documents/${model}/${documentId}`, long)
      .then(r => r.data),
  journal: (id, params) =>
    http.get(`${base}/${id}/journal`, { params }).then(r => r.data),
  journalItems: (id, seq, page = 1, limit = 50) =>
    http
      .get(`${base}/${id}/journal/${seq}`, { params: { page, limit } })
      .then(r => r.data),
};

export const errMsg = e =>
  e?.response?.data?.message || e?.message || String(e);
